import React from 'react';
import { VideoSection } from '../components/VideoSection';
import { ContentSection } from '../components/ContentSection';
import { Button } from '../components/Button';
import { Footer } from '../components/Footer';
import { PaymentIcons } from '../components/PaymentIcons';
import { SecurityBadges } from '../components/SecurityBadges';
import { Header } from '../components/Header';
export function UnboxingPage() {
  return <div className="w-full min-h-full bg-white" data-id="element-166">
      <Header data-id="element-167" />
      <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:px-8" data-id="element-168">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-900" data-id="element-169">
          It's Built Like a Tank (Josh Called It What?!)
        </h2>
        <VideoSection data-id="element-170" />
        <ContentSection data-id="element-171" />
        <div className="flex justify-center gap-4 mt-12 mb-8" data-id="element-172">
          <div className="w-72 self-end" data-id="element-173">
            <Button href="https://secure.shotcraftgolf.com/b29-checkout-129_pr_bump_bundle" data-id="element-174">
              Get 1 Blue Brick
            </Button>
          </div>
          <div className="w-72 flex flex-col items-center" data-id="element-175">
            <span className="text-red-600 text-base mb-2 font-bold bg-yellow-100 px-3 py-1 rounded-full animate-[slideIn_0.5s_ease-out] shadow-sm text-center" data-id="element-176">
              Buy 1 get a second for just $99. That's $70 off + zero extra
              shipping in the U.S.
            </span>
            <Button href="https://secure.shotcraftgolf.com/b29-checkout-2-for-1" data-id="element-177">
              Get 2 Blue Bricks
            </Button>
          </div>
        </div>
        <div className="mt-4 mb-2" data-id="element-178">
          <PaymentIcons data-id="element-179" />
        </div>
        <div className="mb-8" data-id="element-180">
          <SecurityBadges data-id="element-181" />
        </div>
        <div className="mb-8 flex justify-center" data-id="element-182">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bEvbrxAiDwc8USGWLWmKxg/guarantee-1.png" alt="60 Day Money Back Guarantee Badge" className="w-32" data-id="element-183" />
        </div>
      </div>
      <Footer data-id="element-184" />
    </div>;
}